export default (context, inject) => {
  inject('urlHelper', {
    getRoleAnalysisUrl: (countryCode, disciplineCode, careerLevel) => {
      if (typeof careerLevel === 'undefined') {
        return `/${countryCode}/${disciplineCode}`
      }

      return `/${countryCode}/${disciplineCode}?init_career_level=${careerLevel}`
    }
  })
}
